module.exports = __webpack_public_path__ + "static/img/qrcode_258.9eafc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyLogo/qrcode_258.png
// module id = WMZS
// module chunks = 52